export default __webpack_public_path__ + "static/media/Content2-transparent.b8bc98a3.png";